var generateComponentTheme = function generateComponentTheme(_ref) {
  var borders = _ref.borders,
    spacing = _ref.spacing,
    colors = _ref.colors;
  return {
    rootBorderWidth: borders.widthSmall,
    rootBorderColor: colors.contrasts.grey1111,
    rootMargin: spacing.medium,
    editFeedbackMargin: spacing.medium,
    pointsWidth: '5.5rem',
    pointsPadding: spacing.xxSmall,
    pointsMargin: spacing.xSmall,
    pointsSectionPadding: spacing.small,
    dividerMargin: spacing.xSmall,
    pointsPossibleMargin: spacing.small
  };
};
export default generateComponentTheme;